import { ApolloLink } from '@apollo/client'
import TimeoutLink from 'apollo-link-timeout'

const REQUEST_TIMEOUT = 30_000 // 30 sec

// if a call takes too long, we will abort it and return an error
export const timeoutLink = new TimeoutLink(REQUEST_TIMEOUT) as ApolloLink
